import { useMutation, useQueryClient } from "@tanstack/react-query";
import { makeBackendDeleteCallWithJsonResponse } from "../../store/utils/fetch";
import { MUSO_AUTH_TOKEN } from "../../store/utils/routes";
import { promiseEngineEarsHandler } from "../../api/helpers";
import { QUERY_KEYS } from "../../constants/queryKeys";
import { useAppDispatch } from "../../store/hooks";
import { clearMusoData } from "../../store/actions/muso";

export const useDeleteMusoAuthAssociation = () => {
  const queryClient = useQueryClient();
  const dispatch = useAppDispatch();
  return useMutation({
    mutationFn: () => {
      return makeBackendDeleteCallWithJsonResponse<{
        success: boolean;
      }>(MUSO_AUTH_TOKEN).then(promiseEngineEarsHandler);
    },
    onSuccess: () => {
      dispatch(clearMusoData());
      void queryClient.removeQueries({
        queryKey: [QUERY_KEYS.GET_MUSO_AUTH],
      });
    },
  });
};
